import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import {
  Button, Modal, Box, Grid, TextField, Typography, Paper, Checkbox,
  List, Card, CardHeader, ListItemButton, ListItemText, ListItemIcon, Divider
} from '@mui/material';



import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import 'dayjs/locale/es';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DetailsIcon from '@mui/icons-material/Details';
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';
import customerService from '../services/customerService';
import { getConsultantIdentifier } from '../Redux/UsersDucks';
import { setContractFull, setInterview } from '../Redux/TabDucks'
import { useDispatch, useSelector } from 'react-redux';
import { setCargaDatos } from '../Redux/GeneralDuck';
import SelectSearch from 'react-select-search';
//import 'react-select-search/style.css';
import './react-select-search-style.css';
import './swal.css';
import { CreditorService } from '../services/creditorService';
import CreatableSelect from 'react-select/creatable';
import Swal from 'sweetalert2';

function not(a, b) {
  return a.filter((value) => !b.includes(value));
}

function intersection(a, b) {
  return a.filter((value) => b.includes(value));
}

function union(a, b) {
  return [...a, ...not(b, a)];
}

const DemandasTable = ({ causas, loading, customStyles, isDetailModalOpen, isRegisterModalOpen, selectedCase, handleViewDetail, handleCerrarDetail, handleViewRegister, handleCerrarRegister, agregarCausa, bloquearAcciones }) => {
  const dispatch = useDispatch();
  const interview = useSelector((store) => store.tab.interview);
  const contractFull = useSelector((store) => store.tab.contractFull);
  const general = useSelector((store) => store.general)
  const _TAB = useSelector((store) => store.tab);


  const [tribunales, setTribunales] = useState([])
  const [acreedoresList, setAcreedoresList] = useState([])
  const [newCase, setNewCase] = useState({
    participante: 'DDO.', rut: "", rol: "",
    codTribunal: "", nombre: "", fIng: "",
    proc: "", etapa: "", estadoProc: "",
    tribunal: "", demandante: "", identifier: null,
    corte: null,
  });
  const [checked, setChecked] = useState([]);
  const [left, setLeft] = useState([]);
  const [right, setRight] = useState([]);
  const [identifier, setIdentifier] = useState(null);


  const leftChecked = intersection(checked, left);
  const rightChecked = intersection(checked, right);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const acreedores = await CreditorService.getAcreedores()
        setAcreedoresList(acreedores.map((item) => {
          return { value: item.id, name: item.name, label: item.name }
        }))
      } catch (error) {
      }
    }
    fetchData();
    dispatch(setCargaDatos())


    if (_TAB?.customer?.properties?.rut != null && _TAB.customer.properties.rut != "") {
      setIdentifier(_TAB.customer.properties.rut.trim())
    }
    else if (_TAB?.customerFormatted?.identifier != null && _TAB.customerFormatted.identifier != "") {
      setIdentifier(_TAB.customerFormatted.identifier.trim())
    }
  }, [_TAB])

  useEffect(() => {
    if (general.tribunales.length > 0)
      setTribunales(general.tribunales.map((item) => {
        return { value: item.value, name: item.label }
      }))
  }, [general])

  useEffect(() => {
    setLeft(causas);
  }, [causas]);

  useEffect(() => {
    if (interview.causas) {
      setRight(interview.causas)
    }
  }, [interview]);




  useEffect(() => {
    /*
      const nuevaLeft = [];
      left.forEach(l => {
        var r = right.find(p => p.rol == l.rol && p.codTribunal == l.codTribunal)
        if (!r) nuevaLeft.push(l);
      });
      setLeft(nuevaLeft);
      */
  }, [left, right]);









  // Formatear datos y registrar acreedores seleccionados
  const handleRegistrarAcreedores = async () => {
    const consultantIdentifier = getConsultantIdentifier();
    if (!consultantIdentifier) {
      throw new Error('Consultor. Se debe de ingresar en el sistema es requerido su rut.');
    }
    const causas = right.map(row => ({
      id: row.id || 0, // Asegúrate de que el ID sea correcto
      rol: row.rol,
      codTribunal: row.codTribunal,
      nombre: row.nombre,
      proc: row.proc,
      etapa: row.etapa,
      estadoProc: row.estadoProc,
      tribunal: row.tribunal,
      demandante: row.demandante,
      contractServiceId: 0,
      identifier: identifier,
      cosmoId: 0,
      idStatus: 1,
      customerInterviewId: interview.id,
      createdBy: consultantIdentifier,      // Aquí puedes usar el ID del usuario autenticado
    }));
    console.log(causas)

    // Estructura de datos a enviar
    const acreedores = right.map(row => ({
      Identifier: identifier,
      CustomerId: row.customerId,   // Campo según los datos disponibles
      Demandante: row.demandante,   // Asignar correctamente el demandante
      Monto: row.monto || 0,        // Colocar un monto por defecto si no existe
      CreatedBy: consultantIdentifier,      // Aquí puedes usar el ID del usuario autenticado
      IdStatus: 1,                   // IdStatus predeterminado
      customerInterviewId: interview.id,
    }));

    try {
      // await customerService.registrarAcreedores(acreedores);
      var causasActualizadas = await customerService.causasContrato({ CausasContratoDTOs: causas, CustomerInterviewId: interview.id });

      dispatch(setInterview({ causas: causasActualizadas }));
      dispatch(setContractFull({ ...contractFull, allAcreedores: acreedores }));
      setLeft([]);
      // Limpiar selección

    } catch (error) {
      console.error('Error al registrar acreedores:', error);
    }
  };

  const handleAgregarCausa = () => {
    var nCase = newCase;
    nCase.rut = identifier
    agregarCausa(nCase)
    setTimeout(() => { handleCerrarRegister() }, 50)
  }

  const handleChange = (e) => { // Actualiza el estado usando el nombre del input como key
    const { name, value } = e.target;
    setNewCase((prevData) => ({ ...prevData, [name]: value }));
  }


  const handleCreateOption = async (inputValue) => {

    try {
      var id = await CreditorService.AddCreditor(inputValue);

      const opcionDesdeServidor = {
        value: id,
        label: inputValue,
      };

      setAcreedoresList((prev) => [...prev, opcionDesdeServidor]);
      setNewCase((prev) => ({ ...prev, demandante: inputValue, codDemandante: id }));

      Swal.fire({
        title: 'Éxito',
        text: 'Acreedor creado correctamente',
        icon: 'success',
        confirmButtonText: 'Aceptar',
        customClass: {
          popup: 'swal-front'
        }
      })

    } catch (error) {

      Swal.fire({
        title: 'Error',
        text: 'Acreedor no creado',
        icon: 'errot',
        confirmButtonText: 'Aceptar',
        customClass: {
          popup: 'swal-front'
        }
      })

    }
  };


  const handleChangeAcreedor = (item) => {
    if (item == null) {
      setNewCase((prevData) => ({
        ...prevData, demandante: null, codDemandante: null,
      }));
    }
    else {
      const name = acreedoresList.find(opt => opt.value === item.value)?.label || '';
      setNewCase((prevData) => ({
        ...prevData, demandante: name, codDemandante: item.value,
      }));
    }
  }

  const handleChangeTribunales = (value) => {
    if (value == null) {
      setNewCase((prevData) => ({
        ...prevData, codTribunal: null, tribunal: null
      }));
    }
    else {
      const name = tribunales.find(opt => opt.value === value)?.name || '';
      setNewCase((prevData) => ({
        ...prevData, codTribunal: value, tribunal: name
      }));
    }
  }


  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  const numberOfChecked = (items) => intersection(checked, items).length;

  const handleToggleAll = (items) => () => {
    if (numberOfChecked(items) === items.length) {
      setChecked(not(checked, items));
    } else {
      setChecked(union(checked, items));
    }
  };

  const handleCheckedRight = () => {
    setRight(right.concat(leftChecked));
    setLeft(not(left, leftChecked));
    setChecked(not(checked, leftChecked));
  };

  const handleCheckedLeft = () => {
    setLeft(left.concat(rightChecked));
    setRight(not(right, rightChecked));
    setChecked(not(checked, rightChecked));
  };

  const customList = (title, items, add) => (

    <Card>
      <CardHeader
        sx={{ px: 2, py: 1 }}
        avatar={
          <Checkbox
            onClick={handleToggleAll(items)}
            checked={numberOfChecked(items) === items.length && items.length !== 0}
            indeterminate={
              numberOfChecked(items) !== items.length && numberOfChecked(items) !== 0
            }
            disabled={items.length === 0}
            inputProps={{
              'aria-label': 'all items selected',
            }}
          />
        }
        action={add ?
          <Button
            variant="outlined"
            color="primary"
            onClick={handleViewRegister}
            disabled={bloquearAcciones}
          > + Manual </Button> :
          <Button
            variant="contained"
            color="primary"
            onClick={handleRegistrarAcreedores}
            disabled={/*right.length === 0 ||*/ bloquearAcciones}
          > Guardar </Button>
        }
        title={title}
        subheader={`${numberOfChecked(items)}/${items.length} seleccionads`}
      />
      <Divider />
      <List
        sx={{
          width: '100%',
          height: 230,
          bgcolor: 'background.paper',
          overflow: 'auto',
        }}
        dense
        component="div"
        role="list"
      >
        {items.map((value) => {

          return (
            <Grid container alignItems="center">
              <Grid item sm={10}>
                <ListItemButton
                  key={value}
                  role="listitem"
                  onClick={handleToggle(value)}
                  sx={{ display: 'flex', alignItems: 'center' }}>
                  <ListItemIcon>
                    <Checkbox
                      checked={checked.includes(value)}
                      onClick={handleToggle(value)}
                      tabIndex={-1}
                      disableRipple
                    />
                  </ListItemIcon>
                  <div sx={{ display: 'flex', flexDirection: 'column' }}>
                    <ListItemText m={0} primary={`${value.rol}`} />
                    <ListItemText m={0} primary={`${value.tribunal}`} />
                    <ListItemText m={0} primary={`${value.demandante}`} />
                  </div>
                </ListItemButton>
              </Grid>
              <Grid item sm={2} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button onClick={() => handleViewDetail(value)}> <VisibilityIcon /> </Button>
              </Grid>
            </Grid>

          );
        })}
      </List >
    </Card >
  );
  /**
   * 
   * 
   * 
   */

  return (
    <>
      <Typography variant="h5" sx={{ justifyContent: 'center', alignItems: 'center', mb: 3 }}>
        CAUSA PODER JUDICIAL
      </Typography>
      <Grid
        container
        spacing={2}
        sx={{ justifyContent: 'center', alignItems: 'center', mt: 2 }}
      >
        <Grid sm={5} >{customList('Causas Disponibles', left, true)}</Grid>
        <Grid>
          <Grid container direction="column" sx={{ alignItems: 'center' }}>
            <Button
              sx={{ my: 0.5 }}
              variant="outlined"
              size="small"
              onClick={handleCheckedRight}
              disabled={leftChecked.length === 0}
              aria-label="move selected right"
            >
              &gt;
            </Button>
            <Button
              sx={{ my: 0.5 }}
              variant="outlined"
              size="small"
              onClick={handleCheckedLeft}
              disabled={rightChecked.length === 0}
              aria-label="move selected left"
            >
              &lt;
            </Button>
          </Grid>
        </Grid>
        <Grid sm={5} >{customList('Causas de la Entrevista', right, false)}</Grid>
      </Grid>

      {/* modal detalle*/}
      <Modal
        open={isDetailModalOpen}
        onClose={() => handleCerrarDetail()}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="apple-modal" sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 'auto',
        }}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                required
                id="identifier"
                label="Rut"
                name="Identifier"
                value={selectedCase?.rut.trim() || ''}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                required
                id="Rol"
                label="Rol"
                name="Rol"
                value={selectedCase?.rol || ''}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                required
                id="demandante"
                label="Demandante"
                name="Demandante"
                value={selectedCase?.demandante || ''}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                required
                id="Tribunal"
                label="Tribunal"
                name="Tribunal"
                value={selectedCase?.tribunal || ''}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField fullWidth required id="NombreCausa"
                label="Nombre Causa - Caratula." name="NombreCausa" value={selectedCase?.nombre || ''}
              />
            </Grid>
          </Grid>
          <Box sx={{ mt: 3, display: 'flex', justifyContent: 'right' }}>
            <Button
              variant="contained" color="primary" onClick={handleCerrarDetail}
              className="apple-button" startIcon={<CloseIcon />} >
              Cerrar
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* modal Agregar*/}
      <Modal
        open={isRegisterModalOpen}
        onClose={() => handleCerrarRegister()}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="apple-modal"
          sx={{
            position: 'absolute', top: '50%', left: '50%',
            transform: 'translate(-50%, -50%)', width: 'auto'
          }}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth required id="rut" label="Rut" name="rut"
                value={newCase.rut || (_TAB?.customer?.properties?.rut || '')}
                onChange={handleChange} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField fullWidth required id="rol"
                label="Rol" name="rol" value={newCase.rol}
                onChange={handleChange} />
            </Grid>

            <Grid item xs={12} sm={6}>
              <SelectSearch options={tribunales} search
                placeholder="Seleccione Tribunal"
                onChange={handleChangeTribunales} />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField fullWidth required id="nombre"
                label="Nombre Causa - Caratula"
                name="nombre" value={newCase.nombre} onChange={handleChange} />
            </Grid>

            <Grid item xs={12} sm={6}>
              <CreatableSelect isClearable isSearchable
                options={acreedoresList}
                onChange={handleChangeAcreedor}
                onCreateOption={handleCreateOption}
                placeholder="Seleccione o agregue un demandante"
                value={acreedoresList.find((opt) => opt.value === newCase.codDemandante) ?? null}
                styles={{
                  control: (base) => ({ ...base, height: 55, minHeight: 55, }),
                  valueContainer: (base) => ({ ...base, paddingTop: 4, paddingBottom: 4, }),
                  input: (base) => ({ ...base, margin: 0, padding: 0, })
                }}
              />
            </Grid>


          </Grid>
          <Box sx={{ mt: 3, display: 'flex', justifyContent: 'right' }}>
            <Button sx={{ mr: 1 }} variant="contained" color="primary"
              onClick={handleAgregarCausa} className="apple-button" startIcon={<AddIcon />}>
              Crear
            </Button>
            <Button
              variant="contained" color="primary" onClick={handleCerrarRegister}
              className="apple-button" startIcon={<CloseIcon />} >
              Cerrar
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};
export default DemandasTable;
